import React, { useState, useEffect } from 'react';
import './theme/_main.scss';
import FadeInSection from '../../customizations/components/theme/Animations/FadeInSection';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Api, flattenToAppURL } from '@plone/volto/helpers';
import { Link } from 'react-router-dom';
import { rrulestr } from 'rrule';
import { useSelector } from 'react-redux';

const View = (props) => {
  const { data, isEditMode, filteredToolbarProps } = props;
  const [value, setValue] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(new Date());
  const [isClient, setIsClient] = useState(false);
  const [fullDates, setFullDates] = useState([]);
  const [datesOnDay, setDatesOnDay] = useState([]);

  const currentLang = useSelector((state) => state.intl.locale);
  
  const dates = props.content?.items?.map((item) => item['@id']);

  const parseRecurrence = (recurrence) => {
    if (!recurrence) return null;
    try {
      return rrulestr(recurrence);
    } catch (error) {
      console.error('Error parsing recurrence rule:', error);
      return null;
    }
  };

  const apiGetContent = async (pathname) => {
    const api = new Api();
    if (!pathname) return;
    try {
      return await api.get(flattenToAppURL(pathname));
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    if (!dates) return;
    const fetchData = async () => {
      const responses = await Promise.all(dates.map(apiGetContent));
      setFullDates(responses);
    };
    fetchData();
  }, []);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!fullDates) return;
    setDatesOnDay(collectDates(new Date()));
  }, [fullDates]);

  const collectDates = (day) => {
    const collected = [];
    const checkDay = new Date(day);
    checkDay.setHours(0, 0, 0, 0);

    const nextDay = new Date(checkDay);
    nextDay.setDate(nextDay.getDate() + 1);

    fullDates.forEach((date) => {
      const start = new Date(date.start);
      const end = new Date(date.end);

      if (start < nextDay && end >= checkDay && date.review_state === 'published') {
        collected.push(date);
      }

      if (date.recurrence) {
        const rule = parseRecurrence(date.recurrence);
        if (rule) {
          const occurrences = rule.between(checkDay, nextDay, true);
          if (occurrences.length > 0 && date.review_state === 'published' && !collected.includes(date)) {
            collected.push(date);
          }
        }
      }
    });

    return collected;
  };

  const tileContent = ({ date, view }) => {
    if (view === 'month' && collectDates(date).length > 0) {
      return <div className="date-indicator" aria-hidden="true" />;
    }
    return null;
  };

  const onClickDay = (day) => {
    setSelectedDay(day);
    setDatesOnDay(collectDates(day));
  };

  if (!data) {
    return <div>missing data</div>;
  }

  return (
    <section className="calendar-block" aria-labelledby="calendar-heading">
      <FadeInSection>
        <h2 id="calendar-heading" className="visually-hidden">Event Calendar</h2>
        {isClient ? (
          <Calendar
            value={value}
            tileContent={tileContent}
            onClickDay={onClickDay}
            aria-label="Event calendar"
            locale={currentLang}
          />
        ) : (
          <p>Loading calendar...</p>
        )}
      </FadeInSection>

      <FadeInSection>
        <h3 className="selected-day-heading">
          {selectedDay ? selectedDay.toDateString() : 'No Date Selected'}
        </h3>
        {!datesOnDay.length && <p>{data.text}</p>}
      </FadeInSection>

      <div aria-live="polite">
        {datesOnDay.map((date, index) => (
          <div key={index} className="slide-down event-entry">
            <Link to={flattenToAppURL(date['@id'])} key={date.id} className="event-link">
              <article className="event-preview" aria-label={`Event: ${date.title}`}>
                <h2>{date.title}</h2>
                <p>{date.description}</p>
              </article>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default View;
